import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7a9f2c19&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=7a9f2c19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9f2c19",
  null
  
)

export default component.exports